import * as React from 'react';
import {styled, alpha} from '@mui/material/styles';
import {MenuProps, Menu as MuiMenu} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import {IMenu} from "../../interfaces";

const StyledMenu = styled((props: MenuProps) => (
    <MuiMenu
        elevation={0}
        anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({theme}) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function Menu(props: IMenu) {
    const {anchorEl, setAnchorEl, menuList, onChange} = {...props}
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelectionChange = (index: number) => {
        onChange(menuList[index])
        setAnchorEl(null)
    }

    return (
        <StyledMenu
            MenuListProps={{
                'aria-labelledby': 'menu',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {menuList.map((e, index) => <MenuItem
                disableRipple
                key={e}
                dense
                onClick={(_) =>handleSelectionChange(index)}>
                {e}
            </MenuItem>)}
        </StyledMenu>
    );
}